import CityPageTemplate from "../city-template/CityPageTemplate";
import { cantonConfig } from "./data";

export default function CantonPage() {
  return <CityPageTemplate config={cantonConfig} />;
}